module.exports = __webpack_public_path__ + "img/border.1803e9d4.png";